import React from 'react';
import theme from '../../../theme';
import { IGenericIconProps } from './types';

const CashIcon: React.FC<IGenericIconProps> = ({
    width = 24,
    height = 24,
    strokeWidth = '1.5',
    strokeColor = theme.colors.loopEmerald,
    fill = 'none'
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill={fill}
    >
        <path
            d="M18.7681 6H5.26562C3.88491 6 2.76562 7.11929 2.76562 8.5V16C2.76562 17.3807 3.88491 18.5 5.26562 18.5H18.7681C20.1488 18.5 21.2681 17.3807 21.2681 16V8.5C21.2681 7.11929 20.1488 6 18.7681 6Z"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
        />
        <path
            d="M12 9.81641C13.5188 9.81641 14.75 11.0476 14.75 12.5664C14.75 14.0852 13.5188 15.3164 12 15.3164C10.4812 15.3164 9.25 14.0852 9.25 12.5664C9.25 11.0476 10.4812 9.81641 12 9.81641Z"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
        />
        <path
            d="M18.5 8.50024L16.5 8.5"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
        />
        <path
            d="M7.5 16H5.5"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
        />
    </svg>
);

export default CashIcon;
